export default [
    {
        path: '/ums-demo',
        name: 'UMSDemo',
        component: './Demo',
    }
    , {
        path: '/privacy',
        name: 'Privacy',
        component: './Privacy',
    },
    {
        path: '/user',
        component: '../layouts/BlankLayout',
        routes: [
            {
                path: '/user',
                redirect: '/user/login',
            },
            {
                name: '登录',
                icon: 'smile',
                path: '/user/login',
                component: './user/login',
            },
            {
                component: './exception/404',
            },
        ],
    },
    {
        path: '/',
        component: '../layouts/BasicLayout',
        routes: [

            {
                name: '工作台',
                path: '/workbench',
                disabledTooltip: true,
                routes: [
                    {
                        path: '/workbench/index',
                        name: '首页',
                        icon: 'icon-zhuye',
                        component: './FirstPage',
                        hideHeader: true,
                    },
                    {
                        name: '集团监控',
                        icon: 'icon-jituanjiankong',
                        path: '/workbench/groupMonitor',
                        routes: [
                            {
                                name: '集团质量监控',
                                path: '/workbench/groupMonitor/quality',
                                component: './screen/quality',
                                hideHeader: true,
                            },
                            {
                                name: '预警处理监控',
                                path: '/workbench/groupMonitor/alert',
                                component: './screen/alert',
                                hideHeader: true,
                            },
                            {
                                path: '/workbench/groupMonitor/statistics',
                                name: '自助报表',
                                component: './report/statistics',
                                hideHeader: true,
                            },
                            // 告警大屏
                            {
                                component: './render',
                            },
                        ]
                    },
                    {
                        name: '质检分析',
                        icon: 'icon-zhijianfenxi',
                        path: '/workbench/qcAnalysis',
                        routes: [
                            {
                                name: '质检总览',
                                path: '/workbench/qcAnalysis/stats',
                                component: './data/stats',
                                hideHeader: true,
                            },
                            // 质检诊断报告和质检明细报表
                            {
                                component: './render',
                            },
                        ]
                    },
                    {
                        name: '实时风险分析',
                        icon: 'icon-shishifengxianfenxi',
                        path: '/workbench/riskAnalysis',
                        routes: [
                            {
                                name: '实时会话监控',
                                path: '/workbench/riskAnalysis/dialog',
                                component: './monitor/customerMonitor',
                                hideHeader: true,
                            },
                            {
                                name: "组长实时监控",
                                path: '/workbench/riskAnalysis/abnormals',
                                component: './monitor/abnormals',
                                hideHeader: true,
                                tip: '仅有下级的账号可使用'
                            },
                            // 实时告警报表、平台店铺全局告警统计都在这里
                            {
                                component: './render',
                            },
                        ]
                    }

                ]
            },
            {
                name: '服务分析',
                path: '/serviceAnalysis',
                disabledTooltip: true,
                routes: [
                    {
                        name: 'VOC 分析',
                        icon: 'icon-VOCfenxi',
                        path: '/serviceAnalysis/voc',
                        routes: [
                            {
                                name: '商品咨询热点',
                                path: '/serviceAnalysis/voc/hot',
                                hideHeader: true,
                                routes: [
                                    {
                                        name: '咨询原声详情',
                                        path: '/serviceAnalysis/voc/hot/trt',
                                        component: './voc/trt',
                                    },
                                    {
                                        name: '自助洞察分析',
                                        path: '/serviceAnalysis/voc/hot/insight',
                                        component: './voc/insight',
                                        hideHeader: true,
                                    },
                                    {
                                        name: '咨询场景管理',
                                        path: '/serviceAnalysis/voc/hot/scene',
                                        component: './voc/scene',
                                        hideHeader: true,
                                    },
                                    {
                                        component: './render',
                                    },
                                ],
                            },
                            {
                                name: '商品流失分析',
                                path: '/serviceAnalysis/voc/analysis',
                                hideHeader: true,
                                routes: [
                                    {
                                        name: '流失原因分析',
                                        path: '/serviceAnalysis/voc/analysis/result',
                                        component: './voc/result',
                                        hideHeader: true,
                                        hideInMenu: true,
                                    },
                                    {
                                        name: '流失原因分析-doris',
                                        path: '/voc/analysis/dorisresult',
                                        component: './voc/doris_result',
                                        hideHeader: true,
                                        hideInMenu: true,
                                    },
                                    {
                                        name: '流失配置管理',
                                        path: '/serviceAnalysis/voc/analysis/configure',
                                        component: './voc/configure',
                                        hideHeader: true,
                                    },
                                    {
                                        name: '商品流失详情',
                                        path: '/serviceAnalysis/voc/analysis/detail',
                                        component: './voc/detail',
                                    },
                                    {
                                        name: '商品流失详情-doris',
                                        path: '/voc/analysis/dorisdetail',
                                        component: './voc/doris_detail',
                                    },

                                    {
                                        name: '商品管理',
                                        path: '/serviceAnalysis/voc/analysis/goods',
                                        component: './voc/goods',
                                        hideHeader: true,
                                    },
                                    {
                                        component: './render',
                                    },
                                ],
                            },
                            {
                                component: './render',
                            },
                        ],
                    },
                    {
                        name: 'VOC AI',
                        icon: 'icon-a-VOCAIbannerguanggaokuaisutiaozhuanye',
                        path: '/serviceAnalysis/vocai',
                        component: './voc/vocai',
                    },
                    {

                        component: './render',
                    }
                ]
            },
            {
                name: "质检管理",
                path: "/qcManage",
                disabledTooltip: true,
                routes: [
                    {
                        name: '质检方案',
                        icon: 'icon-zhijianfangan',
                        path: '/qcManage/standard',
                        routes: [

                            {
                                name: '质检标准',
                                path: '/qcManage/standard/list',
                                component: './standard/list',
                                hideHeader: true,
                            },
                            {
                                name: '质检项管理',
                                path: '/qcManage/standard/management',
                                component: './standard/management/_layout',
                                hideHeader: true,
                            },

                            {
                                name: '编辑规则',
                                path: '/qcManage/standard/list/edit/:id',
                                component: './standard/edit',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                        ],
                    },
                    {
                        name: '告警推送设置',
                        path: '/qcManage/alarm',
                        icon: 'icon-gaojingtuisongshezhi',
                        hideHeader: true,
                        component: './alarm',
                    },
                    {
                        name: '日志',
                        path: '/qcManage/logs',
                        icon: 'icon-rizhi',
                        hideHeader: true,
                        routes: [
                            {
                                name: '质检标准修订记录',
                                path: '/qcManage/logs/standardLog',
                                component: './standard/log',
                            },
                            {
                                name: '消除识别记录',
                                path: '/qcManage/logs/eliminateLabels',
                                component: './system/eliminateLabels',
                                hideHeader: true,
                            },
                            // TODO 准确度报告
                        ]
                    }
                ]
            },
            {
                name: "任务中心",
                path: "/task",
                disabledTooltip: true,
                routes: [
                    {
                        name: '会话原声',
                        icon: 'icon-huihuayuansheng',
                        path: '/task/dialog',
                        routes: [
                            {
                                name: '质检会话列表',
                                path: '/task/dialog/list',
                                component: './dialog/list',
                                hideHeader: true,
                            },
                            {
                                name: '历史会话查询',
                                path: '/task/dialog/history',
                                component: './dialog/history',
                                hideHeader: true,
                            },
                            // 新建高级搜索
                            {
                                name: '高级搜索设置',
                                path: '/task/dialog/radar',
                                component: './dialog/radar',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                            // 编辑高级搜索
                            {
                                name: '高级搜索设置',
                                path: '/task/dialog/radar/:id',
                                component: './dialog/radar',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                        ],
                    },
                    {
                        name: '人工质检',
                        icon: 'icon-rengongzhijian',
                        path: '/task/check',
                        routes: [

                            {
                                name: '质检任务列表',
                                path: '/task/check/task',
                                component: './check/task',
                                hideHeader: true,
                            },
                            {
                                name: '质检任务详情',
                                path: '/task/check/task/detail/:id',
                                component: './check/detail',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                            {
                                name: '质检任务记录',
                                path: '/task/check/record',
                                component: './check/record',
                                hideHeader: true,
                            },
                            {
                                name: '质检任务详情',
                                path: '/task/check/record/detail/:id',
                                component: './check/detail',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                            {
                                // 人工质检诊断报告
                                component: './render',
                            },
                        ],
                    },
                    {
                        name: '案例管理',
                        icon: 'icon-anliguanli1',
                        path: '/task/case',
                        routes: [
                            {
                                name: '会话案例',
                                path: '/task/case/dialog',
                                component: './case/dialog',
                                hideHeader: true,
                            },
                            {
                                name: '审批详情',
                                path: '/task/case/approve/detail/:id',
                                component: './case/approve/detail',
                                hideHeader: true,
                                hideInMenu: true,
                            },
                            {
                                name: '审批中心',
                                path: '/task/case/approve',
                                component: './case/approve',
                                hideHeader: true,
                            },
                            {
                                name: '案例标签管理',
                                path: '/task/case/label',
                                component: './system/caseLabel',
                                hideHeader: true,
                            },
                        ],
                    },
                    {
                        name: '质培管理',
                        path: '/task/train',
                        icon: 'icon-zhipeiguanli',
                        routes: [
                            {
                                name: '质培任务',
                                icon: 'iconshape-2-line',
                                path: '/task/train/tasks',
                                component: './train/tasks',

                            },
                            {
                                name: '质培任务详情',
                                path: '/task/train/detail/:id',
                                component: './train/detail',
                                hideHeader: true,
                                hideInMenu: true,
                            },

                            {
                                name: '质培任务分析',
                                path: '/task/train/analyse',
                                component: './data/analyse',
                                hideHeader: true
                            },
                            {
                                name: '场景标签管理',
                                path: '/task/train/sceneLabel',
                                component: './system/sceneLabel',
                                hideHeader: true,
                            },
                            {
                                name: "AI 训练场",
                                path: '/task/train/aiTrainning',
                                component: './train/aiTrain',
                            }

                        ]
                    },
                    {
                        name: '质检申诉',
                        icon: 'icon-zhijianshensu',
                        path: '/task/appeal',
                        routes: [

                            {
                                name: '我的申诉',
                                path: '/task/appeal/myself',
                                component: './appeal/myself',
                                hideHeader: true,
                            },
                            {
                                name: '主管申诉处理',
                                path: '/task/appeal/charge',
                                component: './appeal/charge',
                                hideHeader: true,
                            },
                            {
                                name: '质检员申诉处理',
                                path: '/task/appeal/quality',
                                component: './appeal/quality',
                                hideHeader: true,
                            },
                            {
                                name: '任务详情',
                                path: '/task/appeal/detail/:id',
                                component: './appeal/detail',
                                hideHeader: true,
                                hideInMenu: true,
                            },
                        ],
                    }
                ]
            },
            {
                name: '系统管理',
                path: '/system',
                tip: '系统管理不区分平台',
                hidePlatform: true,
                routes: [
                    {
                        name: '店铺管理',
                        icon: 'icon-dianpuguanli',
                        path: '/system/shop',
                        component: './system/shop',
                        tip: '',
                        hideHeader: true,
                    },
                    {
                        name: '子账号管理',
                        icon: 'icon-zizhanghaoguanli',
                        path: '/system/department',
                        component: './system/department',
                        tip: '',
                        hideHeader: true,
                    },
                    {
                        name: '人员管理',
                        icon: 'icon-renyuanguanli',
                        path: '/system/snick',
                        component: './system/snick',
                        tip: '',
                        hideHeader: true,
                    },
                    {
                        name: '角色权限管理',
                        icon: 'icon-jiaosequanxianguanli',
                        path: '/system/role',
                        component: './system/role',
                        tip: '',
                        hideHeader: true,
                    },
                    {
                        name: '组织架构设置',
                        icon: "icon-zuzhijiagoushezhi",
                        path: '/system/org',
                        component: './system/org',
                        tip: '',
                        hideHeader: true,
                    },
                    // 旧布局- 删除start
                    {
                        name: '案例标签管理',
                        path: '/system/caseLabel',
                        component: './system/caseLabel',
                        hideHeader: true,
                    },
                    {
                        name: '场景标签管理',
                        path: '/system/sceneLabel',
                        component: './system/sceneLabel',
                        hideHeader: true,
                    },
                    {
                        name: '消除识别记录',
                        path: '/system/eliminateLabels',
                        component: './system/eliminateLabels',
                        hideHeader: true,
                    },
                    // 旧布局- 删除end

                ],
            },

            // 产品账号可以看的
            {
                name: '企业管理',
                icon: 'icon-renyuanguanli',
                path: '/company',
                routes: [
                    {
                        path: '/company',
                        redirect: '/company/manage',
                    },
                    {
                        name: '企业管理',
                        icon: 'icontime',
                        path: '/company/manage',
                        component: './company/manage',
                        hideHeader: true,
                    },
                    {
                        name: '店铺管理',
                        path: '/company/shop/:id',
                        component: './company/shop',
                        hideInMenu: true,
                        hideHeader: true,
                    },
                ],
            },

            {
                name: '账单管理',
                path: '/bill',
                hideInMenu: true,
                hideHeader: true,
                component: './bill',
            },

            {
                name: 'VOC.AI 报表',
                icon: 'icon-wenzhang',
                path: '/voc_ai_reportConfig',
                routes: [
                    {
                        path: '/voc_ai_reportConfig',
                        redirect: '/voc_ai_reportConfig/configuration',
                    },
                    {
                        name: '报表配置',
                        path: '/voc_ai_reportConfig/configuration',
                        component: './report/statisticsVocAi/vocAIConfigPage',
                        hideHeader: true,
                    },
                    {
                        path: '/voc_ai_reportConfig/statistics',
                        name: 'VOC AI数据洞察',
                        component: './report/statisticsVocAi/insight',
                        hideHeader: true,
                    },

                ],
            },
            {
                name: '质检报表',
                icon: 'icon-wenzhang',
                path: '/reportConfig',
                routes: [
                    {
                        path: '/reportConfig',
                        redirect: '/reportConfig/configuration',
                    },
                    {
                        name: '报表配置',
                        path: '/reportConfig/configuration',
                        component: './report/statistics/configPage',
                        hideHeader: true,
                    },
                    {
                        path: '/reportConfig/statistics',
                        name: '自助报表',
                        component: './report/statistics',
                        hideHeader: true,
                    },
                    {
                        path: '/reportConfig/voc',
                        name: 'VOC洞察报表',
                        component: './voc/insight',
                        hideHeader: true,
                    },
                ],
            },
        ],

    },

]